module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_try_on_dress-52dd445a98ba04cb59e6697088cc8767.jpg";